<script>
export default {
    name: "TextareaInput",
    props: {
        label: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        modelValue: {
            default() {
                return '';
            },
        },
    },
    data() {
        return {
            isFocused: false
        }
    },
    methods: {
        handleFocus: _.debounce(function (value) {
            this.isFocused = value;
        }, 500),

        handleInput: _.debounce(function (value) {
            this.$emit('update:modelValue', value)
        }, 500),
    }
}
</script>

<template>
    <div class="textarea-input">
        <label
            v-if="label"
            class="textarea-input__label"
        >
            {{ label }}
        </label>

        <div class="textarea-input__form">
            <textarea
                rows="4"
                :placeholder="placeholder"
                :value="modelValue"
                @input="handleInput($event.target.value)"
                @focus="handleFocus(true)"
                @blur="handleFocus(false)"
            ></textarea>
        </div>
    </div>
</template>

<style lang="scss">
$bgColor: #f1f4f9;
$borderColor: #e1e8f0;
$textColor: #000000;

.textarea-input {
    position: relative;

    &__label {
        font-size: 14px;
        color: $textColor;
        margin-bottom: .5rem;
        display: inline-block;
    }

    &__form {
        display: flex;
        height: 240px;
        width: 100%;
        border: 2px solid $borderColor;
        border-radius: .5rem;
        background: $bgColor;
        padding: 1rem;

        textarea {
            box-sizing: border-box;
            width: 100%;
            font-size: 1rem;
            color: $textColor;
            background: $bgColor;
            resize: none;
            height: 200px;

            &:focus {
                border: none;
                outline: none;
            }
        }
    }
}
</style>